import angular from 'angular';
import durationService from '../services/duration.service';


const maxMinutes = angular.module('ttb.directives.maxMinutes', [
    durationService,
])
    .directive('maxMinutes', ['durationService', function (durationService) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                const maxMinutes = Number(attrs.maxMinutes);
                const converter = durationService.getConverter(); // todo set config from attrs
                ctrl.$validators.maxMinutes = function (modelValue, viewValue) {

                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty models to be valid
                        return true;
                    }
                    return converter.toMinutes(viewValue) <= maxMinutes;
                };
            }
        };
    }])
    .name;

export default maxMinutes;


// WEBPACK FOOTER //
// ../directives/max-minutes.js